import { render, staticRenderFns } from "./stockInTransitStats.vue?vue&type=template&id=e0fa65d6&scoped=true"
import script from "./stockInTransitStats.vue?vue&type=script&lang=js"
export * from "./stockInTransitStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fa65d6",
  null
  
)

export default component.exports